import { request, downloadRequest,downloadEasyExcel,downloadEasyWord} from './request'
import { Methods } from './models'
import { BaseVue } from "@newview/base-web";
import { Vue } from "vue-property-decorator";
import Router from 'vue-router'
import { QueryWrapper } from "./query";
import { FileinforApi } from "@newview/system-api";
import {getOSSClient} from "@newview/tools";
let OSS = require("ali-oss");

export abstract class BaseApiV2 extends Vue{

    fileinforApi:FileinforApi = new FileinforApi();

    public Methods = Methods;
    public abstract get ProxyName()
    public abstract get ControllerName()

    public baseOption: any = { headers: {} };

    /**
     * 添加请求头
     * @param key 
     * @param value 
     */
    public addHeader(key, value) {
        this.baseOption.headers[key] = value;
    }

    public getUrl(methodName: string, controllerName: string = ''): string {
        controllerName = controllerName == '' ? this.ControllerName : controllerName;
        return `/${this.ProxyName}/${controllerName}/${methodName}`
    }

    /**
     * 验证用户是否互斥登录
     * @returns 
     */
    private async validUserMutex() {
        if (sessionStorage.getItem('globalData') == null) return { issucess: true, msg: '不受控' };
        const _globalData: any = JSON.parse(sessionStorage.getItem('globalData')!);
        if (_globalData.localUser != null && _globalData.localUser != undefined && _globalData.localUser.IsMutex == 2) {
            let dats = await request("/SysApi/OAuth/LoginMutexValidate", { method: Methods.GET, params: { AId: _globalData.localUser.Id, LoginMToken: _globalData.localUser.PCLoginToken, systemType: 1 } });
            return dats.result;
        }
        else return { issucess: true, msg: '开放式' };
    }

    /**
     * 运行Action
     * @param programkey 
     * @param params 
     * @returns 
     */
    public async runAction(programkey, params, projectId: number = 0, childSysId: number = 0, devProd: string = "") {

        const _globalData: any = JSON.parse(sessionStorage.getItem('globalData_Plms')!);
        const projectid = projectId != 0 ? projectId : _globalData.itemInfo.id;
        const childsysid = childSysId != 0 ? childSysId : _globalData.subSysteminfor.id;
        const devprod = devProd != '' ? devProd : (window as any)["devProd"];
        return this.sendUrl("/CalcPythonApi/calc/run_action", { programkey, projectid, childsysid, devprod, params: params == undefined ? {} : params }, Methods.POST)
    }

    public send(data: any, methodName: string, method: Methods, controllerName: string = '', option: any = {}) {
        let transData = { data: data }
        let param = { params: data }
        let newOption = Object.assign(Object.assign({}, this.baseOption), option);
        let options = Object.assign({ method: method }, newOption)
        this.validUserMutex().then((rvalid) => {
            if (!rvalid.issucess) {
                let dlist: BaseVue = new BaseVue();
                dlist.alert(rvalid.msg, () => {
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.replace(window.document.location.origin);
                }, "warning", "异地登录验证提示");
            }
        });
        //whr添加用户使用记录业务功能
        let yewu  = this.ProxyName
        if (this.ProxyName == "ProgressApi" || this.ProxyName == "SecurityApi" ||this.ProxyName =="QualityApi" || this.ProxyName =="InvestApi"){
            if (methodName=="save"|| methodName=="delete"|| methodName=='saves' ||
                methodName=='saveTree' ||methodName == 'saveBatch'
                ||methodName == "delete" || methodName == "deleteByIds"|| methodName=="deleteByFilter" ){
                this.UserRecord()
            }
        }

        //增加es数据入库
        // if(this.ProxyName == "NewviewOaBaseApi" && methodName=="save"){
        //     this.pushEsData(data);
        // }

       return request(this.getUrl(methodName, controllerName), method === Methods.GET ? Object.assign(options, param) : Object.assign(options, transData));
    }


    async pushEsData(data){
        let transData: any= {indexName:'oa_worklog_index', jsonData:JSON.stringify(data)};
        let newOption = Object.assign(Object.assign({}, this.baseOption), {});
        let options = Object.assign({ method: Methods.POST }, newOption)
        request("http://192.168.0.63:9220/esHandle/addDocument",  Object.assign({}, transData));
    }

    /**
     * 用户使用次数保存
     */
    async  UserRecord(){
        var date = new Date;
        var fullYear = date.getFullYear();
        var month = date.getMonth();
        var day = date.getDate();

         let data = fullYear +"-"+ (month+1 >10? (month+1) : "0"+ (month+1)) + "-" + (day>10? day: "0"+ day)
        let _menu: any = JSON.parse(localStorage.getItem("activeMenu")!)
        let  s = {
            //项目
            ProjectId: this.$globalData_Plms.itemInfo.id,
            ProjectName:this.$globalData_Plms.itemInfo.subProjectName,
            //机构
            UnitId:this.$globalData_Plms.institutioninfor.id,
            UnitName:this.$globalData_Plms.institutioninfor.institutionName,
            LineId:this.$globalData_Plms.roadInfo.id,
            UserId: this.$globalData_Plms.localUser.id,
            UserName:this.$globalData_Plms.localUser.userName,
            RealName:this.$globalData_Plms.localUser.userTrueName,
            OperationalModule:_menu.moduleAlias,
            ModulePid:_menu.rootId,
            CareateTime:data,
        }
        var itemInfo = this.$globalData_Plms.menuItems;
        let transData = { data: s }
        let newOption = Object.assign(Object.assign({}, this.baseOption), {});
        let options = Object.assign({ method: Methods.POST }, newOption)
        request("/ComprehensiveApi/operation-log-data/save",  Object.assign(options, transData));
    }

    public sendUrl(url, data: any, method: Methods, option: any = {}) {
        let transData = { data: data }
        let param = { params: data }
        let newOption = Object.assign(Object.assign({}, this.baseOption), option);
        let options = Object.assign({ method: method }, newOption)
        this.validUserMutex().then((rvalid) => {
            if (!rvalid.issucess) {
                let dlist: BaseVue = new BaseVue();
                dlist.alert(rvalid.msg, () => {
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.replace(window.document.location.origin);
                }, "warning", "异地登录验证提示");
            }
        });
        return request(url, method === Methods.GET ? Object.assign(options, param) : Object.assign(options, transData));
    }

    public sendDownload(data: any, methodName: string, method: Methods, fileName: string = '', option: any = {}) {
        let transData = { data: data }
        let param = { params: data }
        let newOption = Object.assign(Object.assign({}, this.baseOption), option);
        let options = Object.assign({ method: method }, newOption)
        return downloadRequest(this.getUrl(methodName), method === Methods.GET ? Object.assign(options, param) : Object.assign(options, transData), fileName)
    }
/**  验证是否为null
   * @param obj
  */
  public isNull(obj) {
    if (obj === '' || obj === null || obj === undefined || obj === 'undefined' || obj === 'null') {
      return true
    }
    return false
  }

    /**
     * 删除数据
     * @param id 
     * @returns 
     */
    public async delete(id: number,token:any="") {
        if(!this.isNull(token)){
            let ossClient = await getOSSClient();
            //获取到行数据Token
              let result:any = await this.fileinforApi.getEntityByToken(token)
              if(result.code==200&&result.data.length>0){
                let fileNames = result.data.map(e=>e.fileName);
                await ossClient.deleteMulti(fileNames, {
                  quiet: true
                });
              }
          }
        return this.send({ id }, "delete", Methods.GET);
    }

    /**
     * 根据Ids删除数据
     * 2025年7月4日修改为Get请求，后端接口是Get类型，zhangjl chenrq  qianmr
     * @param ids 
     * @returns 
     */
    public deleteByIds(ids: string) {
        return this.send({ ids }, "deleteByIds", Methods.GET);
    }

    /**
     * 根据条件删除
     * @param ids 
     * @returns 
     */
    public deleteByFilter(queryWrapper: QueryWrapper) {
            return this.send(queryWrapper.getQuerys(), "deleteByFilter", Methods.POST);
    }
    /**
     * 保存数据
     * @param data 
     * @returns 
     */
    public save(data: any) {
        return this.send(data, "save", Methods.POST);
    }

    /**
     * 批量保存数据
     * @param datas 
     * @returns 
     */
    public saves(datas: any[]) {
        return this.send(datas, "saves", Methods.POST);
    }
    public saveBatch(datas: any[]) {
        return this.send(datas, "saveBatchV2", Methods.POST);//saveBatchV2
    }
    /**
     * 批量保存树状数据
     * @param datas 
     * @returns 
     */
    public saveTree(datas: any[]) {
        return this.send(datas, "saveTree", Methods.POST);
    }

    /**
     * 获取数据条数
     * @param filter 
     * @returns 
     */
    public getCount(queryWrapper: QueryWrapper) {
        return this.send(queryWrapper.getQuerys(), "getCount", Methods.POST);
    }

    /**
     * 判断数据是否存在
     * @param filter 
     * @returns 
     */
    public isExist(queryWrapper: QueryWrapper) {
        return this.send(queryWrapper.getQuerys(), "isExist", Methods.POST);
    }

    /**
     * 根据Id获取数据
     * @param id 
     * @returns 
     */
    public getEntity(id: number) {
        return this.send({ id }, "getEntity", Methods.GET);
    }

    /**
     * 条件查询单条数据
     * @param queryWrapper 
     */
    public getEntityByFilter(queryWrapper: QueryWrapper) {
        return this.send(queryWrapper.getQuerys(), "getEntityByFilter", Methods.POST);
    }

    /**
     * 条件查询数据
     * @param queryWrapper  
     * @returns 
     */
    public getEntities(queryWrapper: QueryWrapper) {
        return this.send(queryWrapper.getQuerys(), "getEntities", Methods.POST);
    }

    /**
     * 条件查询数据
     * @param filter 
     * @param queryWrapper 
     * @returns 
     */
    public getEntitiesDynamic(queryWrapper: QueryWrapper) {
        return this.send(queryWrapper.getQuerys(), "getEntitiesDynamic", Methods.POST);
    }

    /**
     * 分页获取数据
     * @param pageIndex 
     * @param pageSize 
     * @param queryWrapper 
     * @returns 
     */
    public getEntitiesPageDynamic(pageIndex: number | undefined, pageSize: number | undefined, queryWrapper: QueryWrapper) {
        return this.send(queryWrapper.getQuerys(), `getEntitiesPageDynamic?pageIndex=${pageIndex}&pageSize=${pageSize}`, Methods.POST);
    }
    public getEntitiesPageDynamic2(pageIndex: number | undefined, pageSize: number | undefined, queryWrapper: QueryWrapper) {
        return this.send({'queryList': queryWrapper.getQuerys(),'pageIndex':pageIndex,'pageSize':pageSize}, `getEntitiesPageDynamic?`, Methods.POST);
    }

    /**
     * 获取服务器当前时间
     * @returns 
     */
    public getServerTime() {
        return this.send({}, "getServerTime", Methods.GET);
    }


    public download(data: any, methodName: string) {
        return downloadEasyExcel(this.getUrl(methodName), data)
    }

    public downloadWord(data: any, methodName: string) {
        return downloadEasyWord(this.getUrl(methodName), data)
    }

    



}
